import { Logo } from '@/components/decoration/Logo';
import { Button } from '@/components/form/Button';
import { ButtonVariant } from '@/components/form/buttonHelper';
import { FC } from 'react';
import { FiCheck } from 'react-icons/fi';
import { useNavigate } from 'react-router';

interface Props {
  text: string;
}

export const SuccessPage: FC<Props> = ({ text }) => {
  const navigate = useNavigate();

  return (
    <div className="h-full flex-1 flex flex-col items-center justify-center gap-10">
      <Logo className="h-20" />
      <div className="bg-primary-700 h-32 w-32 rounded-full flex items-center justify-center">
        <FiCheck className="text-white h-[90%] w-[90%]" />
      </div>
      <div className="text-center text-lg">
        <div className="font-semibold text-xl">Success!</div>
        <div>{text}</div>
      </div>
      <Button variant={ButtonVariant.Secondary} onClick={() => navigate('/')}>
        Go To Home
      </Button>
    </div>
  );
};
